import { FormGroup } from '@angular/forms';
import { APIFormErrors, FieldOptions, FieldType, FormComponent } from '@bo/ng-forms';

/** Generic fallback message set by @bo/ng-forms FormComponent.attachFormErrors */
const PACKAGE_GENERIC_FORM_ERROR = 'You have some form errors.';

export abstract class AppFormComponent<T> extends FormComponent<T> {
  /**
   * Override in a form to replace the package generic non-field error
   * ("You have some form errors.") with a form-specific message.
   * Real API `non_field_errors` are left unchanged.
   */
  protected getGenericFormErrorMessage(): string {
    return PACKAGE_GENERIC_FORM_ERROR;
  }

  protected override attachFormErrors(formGroup: FormGroup, apiErrors: APIFormErrors, parent = true): void {
    super.attachFormErrors(formGroup, apiErrors, parent);

    if (
      parent &&
      !Object.hasOwn(apiErrors, 'non_field_errors') &&
      formGroup.errors?.['server']?.[0] === PACKAGE_GENERIC_FORM_ERROR
    ) {
      const message = this.getGenericFormErrorMessage();
      if (message !== PACKAGE_GENERIC_FORM_ERROR) {
        formGroup.setErrors({ server: [message] });
      }
    }
  }

  protected override serializeField(option: FieldOptions, value: string[] | string): string[] | string | object {
    if (option.type === FieldType.range) {
      // Convert date field values to ISO string.
      return { lower: value[0], upper: value[1] };
    }
    return value;
  }
}
